import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import AdminLayout from "../../masterLayout/AdminLayout";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import AdminDataTable from "../../components/admin/AdminDataTable";
import { adminApi, handleAdminLogoutIfNeeded } from "../../utils/adminApi";

const AdminTestimonials = () => {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState("");

  const load = async () => {
    const res = await adminApi({ url: "admin/get-all", method: "GET" });
    if (handleAdminLogoutIfNeeded(res)) return;
    if (res.success) setRows(res.data || []);
  };

  useEffect(() => {
    document.title = "Admin Testimonials";
    load().catch(console.error);
  }, []);

  const save = async (e) => {
    e.preventDefault();
    const res = await adminApi({
      url: "admin/add-testimonial",
      method: "POST",
      body: form,
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    setMsg(res.msg || (res.success ? "Added" : "Failed"));
    if (res.success) {
      setForm(null);
      load();
    }
  };

  const del = async (row) => {
    if (!window.confirm("Delete this testimonial?")) return;
    const res = await adminApi({
      url: "admin/del-testimonial",
      method: "POST",
      body: { id: row.id },
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    setMsg(res.msg || (res.success ? "Deleted" : "Failed"));
    if (res.success) load();
  };

  const columns = [
    { key: "id", label: "ID" },
    { key: "name", label: "Name" },
    { key: "position", label: "Position" },
    { key: "description", label: "Description" },
    {
      key: "actions",
      label: "Actions",
      render: (_, row) => (
        <button
          type="button"
          className="admin-btn admin-btn-danger"
          style={{ minHeight: 34, padding: "0 10px" }}
          onClick={() => del(row)}
        >
          <Icon icon="lucide:trash-2" width={16} />
        </button>
      ),
    },
  ];

  return (
    <AdminLayout>
      <div className="admin-ui">
        <AdminPageHeader
          title="Testimonials"
          subtitle={`${rows.length} customer quotes on the public site.`}
          action={
            <button
              type="button"
              className="admin-btn admin-btn-primary"
              onClick={() => setForm({ name: "", position: "", description: "" })}
            >
              <Icon icon="lucide:plus" width={18} />
              Add testimonial
            </button>
          }
        />
        {msg ? <div className="admin-alert admin-alert-info">{msg}</div> : null}

        {form && (
          <div className="admin-form-card">
            <div className="admin-form-head">
              <h6>New testimonial</h6>
              <p>Customer quote for the landing page.</p>
            </div>
            <form onSubmit={save}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Name</label>
                  <input
                    className="form-control"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Position</label>
                  <input
                    className="form-control"
                    value={form.position}
                    onChange={(e) => setForm({ ...form, position: e.target.value })}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Quote</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={form.description}
                    onChange={(e) => setForm({ ...form, description: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="admin-form-actions" style={{ marginTop: 16 }}>
                <button type="submit" className="admin-btn admin-btn-primary">Save</button>
                <button type="button" className="admin-btn admin-btn-ghost" onClick={() => setForm(null)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        <AdminDataTable columns={columns} rows={rows} />
      </div>
    </AdminLayout>
  );
};

export default AdminTestimonials;
